function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke-width:1.68;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.7,16.8c-3.5,3.5-9.3,3.5-12.8,0C0.3,13.3,0.3,7.6,3.9,4s9.3-3.5,12.8,0C20.2,7.6,20.2,13.3,16.7,16.8z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 23.5,
  y1: 23.7,
  x2: 16.7,
  y2: 16.8
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M8.7,12.3v-0.6c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.6-0.7,1.1-1.1c0.5-0.4,0.9-0.7,1-0.9c0.2-0.2,0.3-0.5,0.3-0.8 c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.8,0-1.6,0.2-2.6,0.7L6.6,5.7c1.1-0.6,2.3-0.9,3.6-0.9c1,0,1.9,0.3,2.5,0.8 s0.9,1.2,0.9,2c0,0.6-0.1,1-0.4,1.4c-0.3,0.4-0.7,0.9-1.4,1.4c-0.5,0.4-0.8,0.6-0.9,0.8c-0.1,0.2-0.2,0.4-0.2,0.7v0.5H8.7z  M8.4,14.9c0-0.4,0.1-0.7,0.3-1c0.2-0.2,0.6-0.3,1-0.3c0.4,0,0.7,0.1,1,0.3s0.3,0.5,0.3,1c0,0.4-0.1,0.7-0.3,0.9 c-0.2,0.2-0.6,0.3-1,0.3c-0.4,0-0.8-0.1-1-0.3C8.5,15.6,8.4,15.3,8.4,14.9z"
}));

var SvgSafeSafeDolneMenuFaqWhite = function SvgSafeSafeDolneMenuFaqWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search-bue",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafeSafeDolneMenuFaqWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SafeSafe-dolne-menu-FAQ-white.5bfd3fe3.svg";
export { ForwardRef as ReactComponent };